import React from 'react';

export type CollapseIconProps = {
  fillColor?: string;
};

const CollapseIcon: React.FC<CollapseIconProps> = ({
  fillColor,
}: CollapseIconProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Collapse</title>
      <path
        d="M11.5058 1.6063L7.25367 5.85844L11.4749 10.0797L10.0797 11.4749L5.85844 7.25367L1.60631 11.5058L0.22122 10.1207L4.47335 5.86858L0.252132 1.64736L1.64736 0.252127L5.86858 4.47335L10.1207 0.221215L11.5058 1.6063Z"
        className="summary-panel-order-icon-color"
        fill={fillColor}
      />
    </svg>
  );
};

export default CollapseIcon;
